export enum ContactFunction {
    department = 'Department',
    establishment = 'Establishment'
}